export enum InvestigationSupplementaryStatus {
	UnderFulfilment = 1,
	Fulfilled = 2,
}
